import { render } from "./Navigation.vue?vue&type=template&id=554b79af&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=554b79af&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554b79af"]])

export default __exports__